<script lang="ts">
  import { Card, CardContent } from "$lib/components/ui/card";
  import { browser } from "$app/environment";
  import { sidePanelStore } from "$lib/stores/sidePanelStore";
  import { Box, Building } from "lucide-svelte";
  import Button from "../ui/button/button.svelte";
  import { goto } from "$app/navigation";
</script>

<Card class="w-full space-y-3 border-0 bg-theme-background-primary p-1 font-normal text-theme-text-primary">
  <CardContent class="flex flex-col gap-2 p-2">
    <h3 class="text-xs font-normal uppercase text-theme-green-medium">Notifications</h3>

    {#if $sidePanelStore.inviteToken}
      <div
        class="notification-content flex min-h-16 items-start gap-2 rounded-md border border-sidebar-border bg-theme-background-secondary p-2 dark:border-white/20"
      >
        <Building class="size-5 stroke-1" />
        <div class="flex flex-col gap-2">
          <p class="text-sm font-medium text-theme-text-primary">You've been invited to join a new organization</p>
          <Button
            id="share-sheet-button"
            class={"justift-center flex h-7 w-fit items-center gap-1.5 !rounded-base bg-black px-3 py-1 text-2xs font-normal text-white dark:border-white dark:border-white/20 dark:bg-theme-green dark:text-black dark:hover:text-black"}
            aria-label="Share sheet"
            onclick={() => {
              goto(`/invitation/accept`);
            }}
          >
            Accept
          </Button>
        </div>
        <!-- Add your new notification content here -->
      </div>
    {:else}
      <div class="flex flex-col items-center justify-center gap-4 py-4 text-sm text-theme-text-secondary">
        <Box class="size-8 stroke-1" />
        No new notifications
      </div>
    {/if}
  </CardContent>
</Card>
